export const SET_CURRENT_PROFILE = "SET_CURRENT_PROFILE";
export const SET_FORGOT_PASSWORD_CONFIRMATION_STATUS = "SET_FORGOT_PASSWORD_CONFIRMATION_STATUS";
export const SET_LOGIN_REDIRECT = "SET_LOGIN_REDIRECT";
export const SET_EMAIL_ADDRESS = "SET_EMAIL_ADDRESS";
export const SET_RESET_PASSWORD_BOOLEAN = "SET_RESET_PASSWORD_BOOLEAN";
export const SET_PROFILE_DETAILS = "SET_PROFILE_DETAILS";
export const SET_FORGOT_PASSWORD_ERROR_MESSAGE = "SET_FORGOT_PASSWORD_ERROR_MESSAGE";
export const SET_EDIT_PROFILE_SUCCESS_MESSAGE = "SET_EDIT_PROFILE_SUCCESS_MESSAGE";
export const SET_EDIT_PROFILE_ERROR_MESSAGE = "SET_EDIT_PROFILE_ERROR_MESSAGE";
export const SET_LOGIN_REDIRECT_FROM_RESET_PASSWORD = "SET_LOGIN_REDIRECT_FROM_RESET_PASSWORD";
export const SET_IS_GET_PROFILE_PENDING = "SET_IS_GET_PROFILE_PENDING";
export const SET_IS_EDIT_PROFILE_PENDING = "SET_IS_EDIT_PROFILE_PENDING";